var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/site-logo.tsx";
const _excluded = ["className", "theme"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import classNames from 'classnames';
import React from 'react';
import { useLogo } from 'soapbox/hooks';
import { Icon } from './ui';
/** Display the most appropriate site logo based on the theme and configuration. */
const SiteLogo = _ref => {
  let {
      className,
      theme
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const logo = useLogo();
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/alt-text
    React.createElement(Icon, _extends({
      className: classNames('text-primary-500', 'object-contain', className),
      src: logo
    }, rest, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 21,
        columnNumber: 5
      }
    }))
  );
};
export default SiteLogo;